import client from '../../config/api';
import { LOCAL_SET_CURRENT_USER } from './mutations/mutationTypes';

function handleError(error) {
  throw error;
}

export default {
  async USERS_GET_CURRENT({ commit }) {
    try {
      const result = await client.get('/users/current');
      commit(LOCAL_SET_CURRENT_USER, result.data);
      commit('SET_CURRENT_USER', result.data, { root: true }); // We still have the current user not refactored on root state
      return result.data;
    } catch (error) {
      console.warn(error);
      handleError(error);
    }
  },
};
